import styled, { css } from 'styled-components';
import theme from 'shared/theme';
import { tint } from 'src/components/globals';
import { MEDIA_BREAK } from 'src/components/layout';

export const StyledSegmentedControl = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid #e3e7ed;
  border-radius: 8px;
  overflow: hidden;
  overflow-x: scroll;
  position: ${props => (props.sticky ? 'sticky' : 'relative')};
  z-index: ${props => (props.sticky ? '13' : '1')};
  background-color: #ffffff;

  ${props =>
    props.sticky &&
    css`
      top: ${props => (props.stickyOffset ? `${props.stickyOffset}px` : '0')};
    `};

  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background: transparent; /* make scrollbar transparent */
  }

  @media (max-width: ${MEDIA_BREAK}px) {
    max-width: 100vw;
    position: ${props => (props.mobileSticky ? 'sticky' : 'relative')};
    top: ${props =>
      props.mobileStickyOffset ? `${props.mobileStickyOffset}px` : '0'};
    border-radius: 0px;
  }
`;

export const StyledSegment = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  flex: 1 0 auto;
  font-weight: 600;
  color: ${props =>
    props.isActive ? theme.text.blue : theme.community.darkNavy};
  text-align: left;
  margin-right: 40px;
  font-size: 18px;
  font-family: Lato;
  border-bottom: 2px solid #ffffff;
  border-bottom: ${props =>
    props.isActive ? `2px solid ${theme.community.indigo}` : ''};
  &:hover {
    border-bottom: ${props =>
      props.isActive
        ? `2px solid ${theme.community.indigo}`
        : `2px solid ${tint(theme.bg.wash, -16)}`};
    color: ${props => (props.isActive ? theme.community.indigo : '#464AC9')};
    cursor: pointer;
  }

  @media (max-width: ${MEDIA_BREAK}px) {
    &:hover {
      background: ${theme.bg.default};
    }

    &:active {
      background: ${theme.bg.wash};
    }
  }

  @media (min-width: ${MEDIA_BREAK}px) {
    ${props =>
      props.hideOnDesktop &&
      css`
        display: none;
      `}
  }
`;
